export * from './tips.module';
export * from './tip/tip.component';
export * from './tip.model';
export * from './tip.service';
export * from './paginated-tips.model';